/** Canonical icon container shape (16px — brand radius.lg / tailwind `xl`). */
export const iconBoxShape = "rounded-xl";

const iconBoxShell =
  "inline-flex items-center justify-center rounded-xl";

const iconBoxSizeClasses = {
  xs: "h-8 w-8",
  sm: "h-9 w-9",
  md: "h-10 w-10",
  lg: "h-11 w-11",
  xl: "h-12 w-12",
  "2xl": "h-14 w-14",
};

/** @param {"xs"|"sm"|"md"|"lg"|"xl"|"2xl"} size */
export function iconBoxClass(size, toneClass = "", extra = "") {
  return [iconBoxShell, iconBoxSizeClasses[size], toneClass, extra]
    .filter(Boolean)
    .join(" ");
}

/** Same as iconBoxClass but uses flex for row/column layouts. */
export function iconBoxFlexClass(size, toneClass = "", extra = "") {
  return iconBoxClass(size, toneClass, extra).replace("inline-flex", "flex");
}
